module.exports = __webpack_public_path__ + "img/teslon-carenation-sm.7e3232da.png";